import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WorkQueuesTable from './WorkQueuesTable';
import * as lookupSlice from '../../../data/lookup.slice';
import * as monitoringSlice from '../../../data/monitoring.slice';
import * as securitySlice from '../../../data/security.slice';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import PageHeader from '../../controls/PageHeader';

const PREFIX = 'WorkQueues';

const classes = {
  container: `${PREFIX}-container`,
  content: `${PREFIX}-content`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  [`& .${classes.content}`]: {
    display: 'flex',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export default function WorkQueues() {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();

  const userRoles = useAppSelector(securitySlice.selectUserRoles);
  const workQueues = useAppSelector(monitoringSlice.selectWorkQueues);
  const loadingWorkQueues = useAppSelector(
    monitoringSlice.selectLoadingWorkQueues,
  );

  React.useEffect(() => {
    dispatch(monitoringSlice.fetchWorkQueuesAsync());
    dispatch(securitySlice.fetchUserRolesAsync());
  }, []);

  return (
    <StyledBox className={classes.container}>
      <PageHeader title={t('workQueue.title')} />
      <Box className={classes.content}>
        <WorkQueuesTable
          userRoles={userRoles}
          workQueues={workQueues}
          loading={loadingWorkQueues}
        />
      </Box>
    </StyledBox>
  );
}
